export const TEMPLATES_UPLOAD_SIZE_LIMIT = 50 * 1024 * 1024; // 50 MB
export const TEMPLATES_UPLOAD_COUNT_LIMIT = 1;
